import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_REC002_Request,
  IAPI_REC002_Response,
  IAPI_REC009_Request,
  IAPI_REC009_Response,
} from "../../../type/apiType/index";

// 請求詳細表示API
const httpAPI_REC002 = async (
  param: IAPI_REC002_Request
): Promise<IAPI_REC002_Response> => {
  const res = await http.post(ApiUrl.API_REC002, {
    ...param,
  });
  return res.data;
};

// 入金状況更新API
const httpAPI_REC009 = async (
  param: IAPI_REC009_Request
): Promise<IAPI_REC009_Response> => {
  const res = await http.post(ApiUrl.API_REC009, {
    ...param,
  });
  return res.data;
};

export { httpAPI_REC002, httpAPI_REC009 };
